import { createFileRoute, redirect } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { GeoSpecialtyHub } from "@/pages/GeoHub";
import {
  getAllPublishedCitiesForSpecialty,
  getSpecialtyBySlug,
} from "@/data/geoSeoData";

// §584 — livello intermedio della gerarchia /medici: elenca le città pubblicate
// di una specialità. Una specialità senza città pubblicate NON produce una pagina
// vuota: risponde 301 verso la pagina di specialità, come già fanno le coppie
// non pubblicate in medici.$specialty.$city.tsx.
export const Route = createFileRoute("/medici/$specialty/")({
  beforeLoad: ({ params }) => {
    const specialty = getSpecialtyBySlug(params.specialty);
    if (!specialty || getAllPublishedCitiesForSpecialty(params.specialty).length === 0) {
      throw redirect({ to: "/specialita", replace: true, statusCode: 301 });
    }
  },
  head: ({ params }) => {
    const specialty = getSpecialtyBySlug(params.specialty);
    const name = specialty?.name ?? "Specialità";
    return buildRouteHead({
      pathname: `/medici/${params.specialty}`,
      title: `Refertius per ${name}: città disponibili | Refertius`,
      description: `Le città in cui è disponibile una pagina locale Refertius per ${name.toLowerCase()}, con contesto sanitario territoriale.`,
    });
  },
  component: GeoSpecialtyRoute,
});

function GeoSpecialtyRoute() {
  const { specialty } = Route.useParams();
  return <GeoSpecialtyHub specialtySlug={specialty} />;
}
